var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "states-bar-container" } },
    [
      _c("progress-bar", {
        attrs: {
          progress: "",
          responsive: false,
          "dynamic-scroll": false,
          steps: _vm.applicationStatuses,
          "selected-steps": _vm.currentApplicationStatus,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }